import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5007afde&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007afde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5007afde')) {
      api.createRecord('5007afde', component.options)
    } else {
      api.reload('5007afde', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=5007afde&scoped=true", function () {
      api.rerender('5007afde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/details.vue"
export default component.exports